import { module } from 'modujs';
import Plyr from 'plyr';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.player = new Plyr(this.el);
    }

    destroy() {
        if(this.player) {
            this.player.destroy()
        }
    }
}
